module.exports = __webpack_public_path__ + "img/f7a47eeca27b9810ae0a959ce1eebd9c.svg";